/**
 * Dreamy Walls – theme.js
 * Mobile menu toggle, testimonial slider, basic UI
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const drawer = document.querySelector('[data-dw-drawer]');
    if (!drawer) return;

    const openBtn = document.querySelector('[data-dw-drawer-open]');
    const closeBtn = document.querySelector('[data-dw-drawer-close]');
    const backdrop = drawer.querySelector('[data-dw-drawer-backdrop]');

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Testimonial slider ---------- */
  function initTestimonialSlider() {
    const root = document.querySelector('[data-dw-testimonials]');
    if (!root) return;

    const track = root.querySelector('[data-dw-testimonials-track]');
    const slides = root.querySelectorAll('[data-dw-testimonial-slide]');
    const dots = root.querySelectorAll('[data-dw-testimonial-dot]');
    if (!track || slides.length === 0) return;

    let index = 0;

    function goTo(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === index);
        dot.setAttribute('aria-selected', j === index ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    // Optional autoplay
    var autoplay = root.getAttribute('data-autoplay');
    if (autoplay === 'true' && slides.length > 1) {
      setInterval(function () {
        goTo(index + 1);
      }, 6000);
    }

    goTo(0);
  }

  /* ---------- Social posting carousel ---------- */
  function initSocialCarousel() {
    const roots = document.querySelectorAll('[data-dw-social-carousel]');
    roots.forEach(function (root) {
      const track = root.querySelector('[data-dw-social-track]');
      const slides = root.querySelectorAll('[data-dw-social-slide]');
      const prevBtn = root.querySelector('[data-dw-social-prev]');
      const nextBtn = root.querySelector('[data-dw-social-next]');
      const dots = root.querySelectorAll('[data-dw-social-dot]');
      const slideCount = slides.length;
      if (!track || slideCount === 0) return;

      let index = 0;
      const count = parseInt(root.getAttribute('data-slide-count'), 10) || slideCount;
      const speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;

      function goTo(i) {
        index = i % count;
        const pct = count > 1 ? (index * (100 / count)) : 0;
        track.style.transform = 'translateX(-' + pct + '%)';
      }

      var autoplay = root.getAttribute('data-autoplay');
      if (autoplay === 'true' && count > 1) {
        setInterval(function () {
          goTo((index + 1) % count);
        }, speed);
      }

      goTo(0);
    });
  }

  /* ---------- Search modal toggle (optional) ---------- */
  function initSearchToggle() {
    var toggle = document.querySelector('[data-dw-search-toggle]');
    var panel = document.querySelector('[data-dw-search-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.getAttribute('aria-hidden') !== 'false';
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      panel.hidden = !open;
      if (open) {
        var input = panel.querySelector('input[type="search"], input[name="q"]');
        if (input) input.focus();
      }
    });
  }

  ready(function () {
    initMobileMenu();
    initTestimonialSlider();
    initSocialCarousel();
    initSearchToggle();
  });
})();
